module.exports = __webpack_public_path__ + "static/media/terms.ed0c11cb.jpg";